// Public runtime package entry for browser initial source loading and compile helpers.
// It re-exports compiler APIs so standalone bundles keep the current surface.
export * from '@lentystyle/compiler'
export { applyLuisToDocument } from './style'
export {
  compileFromDom,
  loadLuisStylesheetLinks,
  initLuisStylesheetAutoLoader,
  autoInitLuisStylesheetLoader,
} from './runtime/stylesheet-links'
export { registerRuntimeFeature } from './runtime/features'

import { autoInitLuisStylesheetLoader } from './runtime/stylesheet-links'
import { captureRuntimeCoreScriptSource } from './runtime/features'
import { installRuntimeLogDispatcher } from './runtime/logging/dispatcher'

// Start initial `.luis` scanning when the runtime loads in a browser.
captureRuntimeCoreScriptSource()
installRuntimeLogDispatcher()
autoInitLuisStylesheetLoader()
